/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：931
 */

module.exports = {
  networkDialog: "networkError_networkDialog__17FC1",
  networkContent: "networkError_networkContent__1GH32",
  networkText: "networkError_networkText__3Oikh",
  networkFooterWrapper: "networkError_networkFooterWrapper__35zhC"
}
